import { render, staticRenderFns } from "./BranchList.vue?vue&type=template&id=9e84572e&"
import script from "./BranchList.vue?vue&type=script&lang=js&"
export * from "./BranchList.vue?vue&type=script&lang=js&"
import style0 from "./BranchList.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports